import React, { useState } from 'react'
import { Button } from 'antd'
import { ArrowLeftOutlined, CheckCircleFilled } from '@ant-design/icons'
import intl from 'react-intl-universal'
import './index.scss'
import { useLoginStore } from '@/store/loginStore'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { LOGIN_PATH } from '@/routers/login'
import { loginSuccess } from '@/utils/utils'
import { weChatLogin, smsLogin } from '@/services/login'
import { CLIENT_TYPE } from '@/config/default'

const SelectAccount = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const { thirdInfo, selectAccounts, setShowSelectAccount } = useLoginStore()
  const [selectedId, setSelectedId] = useState('')

  const handleSelect = (account) => {
    setSelectedId(account.enterpriseCode)
  }

  const handleConfirm = async () => {
    const selected = selectAccounts?.find(item => item.enterpriseCode === selectedId)
    // const state = searchParams.get('state')
    try {
      if (thirdInfo?.type === 'wechat') {
        // 个人微信登录选择账号
        const res = await weChatLogin({
          unionId: thirdInfo?.unionId,
          openId: thirdInfo?.openId,
          enterpriseCode: selectedId,
          clientType: CLIENT_TYPE.PC,
          account: selected?.account,
        })
        if (res.status) {
          loginSuccess(res.loginResponse)
        }
      } else if (thirdInfo?.type === 'SMS') {
        // 短信登录选择账号
        const res = await smsLogin({
          enterpriseCode: selectedId,
          mobile: thirdInfo?.mobile,
          smsCaptcha: thirdInfo?.preLoginCaptcha,
        })
        loginSuccess(res)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const onBack = () => {
    setShowSelectAccount(false)
    setSearchParams({})
    navigate(LOGIN_PATH)
  }

  return (
    <div className='bindAccount-wrapper'>
      <div className='bindAccount-title'>
        <ArrowLeftOutlined onClick={onBack} />
        {intl.get('login.selectAccount')}
      </div>
      <div className='bindAccount-subtitle'>{intl.get('login.multipleAccountsDetected')}</div>

      <div className='bindAccount-list'>
        {selectAccounts?.map((item) => {
          const isSelected = selectedId === item.enterpriseCode
          return (
            <div
              key={item.enterpriseCode}
              className={`bindAccount-item ${isSelected ? 'selected' : ''}`}
              onClick={() => handleSelect(item)}
            >
              <div className='bindAccount-item-body'>
                <div className='bindAccount-item-row enterprise-name'>{item.enterpriseName}</div>
                <div className='bindAccount-item-row'>
                  <span className='bindAccount-item-label'>{intl.get('login.enterpriseCodeLabel')}</span>
                  <span className='bindAccount-item-value'>{item.abbrName || item.enterpriseCode}</span>
                </div>
                <div className='bindAccount-item-row'>
                  <span className='bindAccount-item-label'>{intl.get('login.loginAccountLabel')}</span>
                  <span className='bindAccount-item-value'>{item.account}</span>
                </div>
              </div>
              <div className={`bindAccount-item-check ${isSelected ? 'visible' : ''}`}>
                <CheckCircleFilled />
              </div>
            </div>
          )
        })}
      </div>

      <Button
        className='bindAccount-btn'
        type='primary'
        disabled={!selectedId}
        onClick={handleConfirm}
      >
        {intl.get('login.confirmLogin')}
      </Button>
    </div>
  )
}

export default SelectAccount